import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from '../service/api-request.service'

@Component({
  selector: 'notice-of-privacy',
  templateUrl: './notice-of-privacy.component.html',
  styleUrls: ['./notice-of-privacy.component.scss']
})
export class NoticeOfPrivacyComponent implements OnInit {

  privacy: any;
  privacyText: any;
  privacyImg: any;
  merchant: any;

  constructor(
    private apiRequestsService: ApiRequestService,
  ) { }

  ngOnInit() {
    let _ = this;
    let urlParse = location.href.split('/');
    let legaWarning = urlParse[4];
    let getWord = urlParse[3];
    _.merchant = getWord;
    if (legaWarning == 'aviso-de-privacidad'){
      _.apiRequestsService.getDesign(_.merchant).subscribe(data => {
        _.privacyImg = data['results'][0]['_configuration']['design'].logo;
        _.privacy = data['results'][0]['_configuration']['footer']['links'][0].title;
        _.privacyText = data['results'][0]['_configuration']['footer']['links'][0].content;
        var output = document.getElementById("privacyTextContent");
        var htmlButton = _.privacyText;
        output.innerHTML = htmlButton + output.innerHTML;
        var privacyTitle = document.getElementById('privacyTitle');
        var privacyInserTitle = _.privacy;
      });
    }
  }

}
